const SlideStatsMobile = class SlideStatsMobile{
    constructor(){

    }

    init(){
        this.slideStatsMobile();
    }

    slideStatsMobile() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 350,
            fade: false,
            autoplay: false,
            cssEase: 'linear',
            arrows: false
        };

        if ($('[data-js="slide-mobile"]').length) {
            let statsSlider = $('[data-js="slide-mobile"]');

            statsSlider.slick(settings);

            slickStatsCarousel();

            $(window).on('resize', function () {
                slickStatsCarousel();
            });
        }


        function  slickStatsCarousel() {
            let statsSlider = $('[data-js="slide-mobile"]');
            if ($(window).width() > 800) {
                if (statsSlider.hasClass('slick-initialized')) {
                    statsSlider.slick('unslick');
                }
                return
            }
            if (!statsSlider.hasClass('slick-initialized')) {

                return statsSlider.slick(settings);
            }
        }
    }
};

export {SlideStatsMobile}


// WEBPACK FOOTER //
// ./static/js/components/SlideStatsMobile.js